import { useMutation } from '@tanstack/react-query';
import { getApiRouteOrMock } from 'api/api.utils';
import { EApiRoutes } from 'api/api.utils';
import useAxios from 'hooks/useAxios';

import { ProjectCategory } from '../constants';

interface ThumbnailUpdateParams {
    projectId: string;
    category: ProjectCategory;
    thumbnailImageUrl: string;
}

/**
 * Custom hook for updating thumbnail images for both projects and portals
 * @returns mutation function and state
 */

export const useThumbnailUpdate = () => {
    const axios = useAxios();

    const updateThumbnail = useMutation(
        async ({ projectId, category, thumbnailImageUrl }: ThumbnailUpdateParams) => {
            if (category === ProjectCategory.PORTAL) {
                // For portals, use the portal settings API
                return await axios.put(
                    getApiRouteOrMock(EApiRoutes.PORTAL_SETTINGS),
                    { thumbnailImageUrl },
                    { 'x-portal': projectId }
                );
            } else {
                // For projects, use the publisher API
                return await axios.put(
                    getApiRouteOrMock(EApiRoutes.PUBLISHER),
                    { thumbnailImageUrl },
                    { 'x-publishers': projectId }
                );
            }
        }
    );

    return {
        updateThumbnail: updateThumbnail.mutateAsync,
        isLoading: updateThumbnail.isLoading,
        error: updateThumbnail.error,
        isSuccess: updateThumbnail.isSuccess
    };
};
